import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationTraceService {
  private _previousUrl: string | null = null;
  private _currentUrl: string | null = null;

  readonly initialReferrer: string = document?.referrer ?? '';
  readonly navigationType: string = this.getNavigationType();

  constructor(private readonly _router: Router) {
    this._currentUrl = this._router.url;

    this._router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        this._previousUrl = this._currentUrl;
        this._currentUrl = e.urlAfterRedirects;
      });
  }

  get previousUrl(): string {
    return this._previousUrl ?? '';
  }

  get currentUrl(): string {
    return this._currentUrl ?? this._router.url;
  }

  private getNavigationType(): string {
    try {
      const entries = performance.getEntriesByType('navigation');
      if (entries && entries.length > 0) {
        return (entries[0] as PerformanceNavigationTiming).type ?? '';
      }
    } catch {
      // ignore
    }

    return '';
  }
}
